<template>
  <div class="Container" style="width: 100%">

    <table>
      <tr>
        <th></th>
      </tr>
      <tr v-for="item in gateways">
        <td>
          <el-radio v-model="id.id" :label="item.id">{{item.name}}: {{item.id}}</el-radio>
        </td>
      </tr>
    </table>

  </div>

</template>

<script>
  export default {
    name: "gateway_choice",
    props: {
      gateways: {
        type: Array,
        required: true
      }, id: {
        type: Object,
        required: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../../styles/variables.scss";

  div {
    table {
      width: 100%;
      height: 100%;
      border-collapse: collapse;
      margin: 0px 0 0;
      tr {

        //text-align: center;

        td {
          border-bottom: 1px;
          border-top: 1px solid transparent;
          border-collapse: collapse;
          border-color: $darkTransparentSoft;
          background-color: $whiteTransparentSoft;
          padding-top: 20px;
          padding-bottom: 10px;
          border-left-width: 6px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/settings/newGateWay/subComponents/gateway_choice.vue